import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AppApiInterface } from 'src/app/app.api';

@Injectable({providedIn: 'root'})

export class DashboardService {

    constructor(
        private httpClient: HttpClient,
    ){}

    getAllIndicators(): Observable<any[]> {
        return this.httpClient.get<any>(`${AppApiInterface.IMALI_API}/dashboard`)
            .pipe(map(data =>data[0]))
    }
}